"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HandleClientProvider = void 0;
const hex_1 = require("../../utils/hex");
/**
 * Abstract class `HandleClientProvider` serving as a template for
 * classes that provide methods to interact with different handle providers.
 *
 * @template T - The type of data returned by the `getAllData` method.
 */
class HandleClientProvider {
    /**
     * Handles API rejection feedback for handle-specific requests.
     * @param {Promise<Response>} api - The API response, usually from fetch().
     * @param {HEX} handle - The handle supplied to the lookup.
     * @returns
     */
    __handleResponse(api, handle) {
        return __awaiter(this, void 0, void 0, function* () {
            return api
                .then((res) => res.json())
                .catch((e) => {
                console.error(`Something went wrong while fetching this Handle: ${handle.value}.${(0, hex_1.isHex)(handle.value)
                    ? ` You may need to convert the Handle name to UTF-8 before providing it to this function.`
                    : ''} Here is the full error:`, e);
                return {};
            });
        });
    }
}
exports.HandleClientProvider = HandleClientProvider;
